import React, { useEffect, useState } from 'react';
import initFirebase from 'Utils/firebase';
import fetchInternalRemoteConfig from 'Utils/fetchInternalRemoteConfig';
import remoteConfigDefaults from 'Utils/remoteConfigDefaults';
import waitForFirebaseRemoteConfig from 'Utils/waitForFirebaseRemoteConfig';

function mapFirebaseConfigs (remoteConfigs) {
  const flags = {};
  for (const [key, config] of Object.entries(remoteConfigs)) {
    flags[key] = config.asString();
  }
  return flags;
}

async function fetchFirebaseRemoteConfig () {
  await waitForFirebaseRemoteConfig();

  const { remoteConfig } = initFirebase();
  if (!remoteConfig) {
    throw new Error('Firebase remoteConfig unavailable');
  }

  await remoteConfig.fetchAndActivate();
  return mapFirebaseConfigs(remoteConfig.getAll());
}

function withRemoteConfig (Component) {
  const RemoteConfig = props => {
    const [config, setConfig] = useState({});

    useEffect(() => {
      if (!process.env.BROWSER) return;

      let cancelled = false;

      const load = async () => {
        try {
          const internalConfig = await fetchInternalRemoteConfig();
          if (!cancelled) setConfig(internalConfig);
          return;
        } catch (error) {
          console.warn('[remoteConfig:internal]', error);
        }

        try {
          const firebaseConfig = await fetchFirebaseRemoteConfig();
          if (!cancelled) setConfig(firebaseConfig);
          return;
        } catch (error) {
          console.warn('[remoteConfig:firebase]', error);
        }

        if (!cancelled) {
          console.warn('[remoteConfig:defaults] using in-app defaults');
          setConfig(remoteConfigDefaults);
        }
      };

      load();

      return () => {
        cancelled = true;
      };
    }, []);

    return <Component { ...props } config={ config } />;
  };

  if (Component.getInitialProps) {
    RemoteConfig.getInitialProps = Component.getInitialProps;
  }

  return RemoteConfig;
}

export default withRemoteConfig;
